import React, { useState } from "react";
import { fetchAllUserLanguages } from "../../../services/api/language";
import { useQuery } from "@tanstack/react-query";
import AddLanguagesModal from "../../CompleteYourProfile/components/AddLanguagesModal";
import { getLanguageLabel } from "../../../utils/helpers";

const AddEditLanguage = ({ userId }) => {
  const [isAddLanguageModalOpen, setIsAddLanguageModalOpen] = useState(false);
  const {
    isPending: isLanguagesLoading,
    error: isLanguagesError,
    data: languagesData,
    refetch: refetchAllUserLanguages,
  } = useQuery({
    queryKey: ["languages", userId],
    queryFn: () => fetchAllUserLanguages(userId ? { userId } : undefined),
  });

  return (
    <div className="mt-6 border-b pb-4">
      <div className="bg-light px-4 py-2 rounded-md flex justify-between items-center ">
        <h6 className="text-dark font-normal">Languages</h6>
        <i
          className="fa-light fa-pencil text-gray-900 cursor-pointer"
          onClick={() => setIsAddLanguageModalOpen(true)}
        ></i>
      </div>
      <div className="flex flex-wrap gap-4 mt-4 ml-4">
        {languagesData?.data?.map((language, index) => (
          <p className="px-4 py-1 bg-light rounded-sm" key={index}>
            {getLanguageLabel(language?.language)} - {language?.proficiency}
          </p>
        ))}
      </div>

      {isAddLanguageModalOpen && (
        <AddLanguagesModal
          open={isAddLanguageModalOpen}
          close={setIsAddLanguageModalOpen}
          refetchAllUserLanguages={refetchAllUserLanguages}
          languagesData={languagesData}
          targetUserId={userId}
        />
      )}
    </div>
  );
};

export default AddEditLanguage;
